import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/auth0_signup_screen.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Register", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, " This page will allow you to register as a user with the Participant Portal and check the status of your application once submitted. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, " To do so, click 'Register' below, and click the 'Sign Up' button on the next screen: ", -1)
const _hoisted_5 = { style: {"display":"flex","justify-content":"center","align-items":"center","height":"100%"} }
const _hoisted_6 = { key: 1 }

import { onMounted, ref } from 'vue'
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ParticipantRegistration',
  setup(__props) {

    const auth0 = useAuth0();

    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };


    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false

    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
            }
        } catch {
            console.log('Not Authenticated.');
        }
    });

    const login = () => {
        if (!auth0) {
            console.log('Hit !auth0 on Register Button');
            return;
        }
        console.log('Hitting auth0.login on Register');
        auth0.login({
            appState: {
                target: "/application",
            },
            authorizationParams: {
                prompt: "login",
                screen_hint: "signup",
            }
        });
    };




return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_form, { ref: "form" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, { density: "compact" }, {
          default: _withCtx(() => [
            (_unref(unregistered))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _hoisted_4,
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_img, {
                      src: _imports_0,
                      alt: "Wyoming Department of Health",
                      style: {"width":"250px","max-height":"462px","float":"inherit"}
                    })
                  ]),
                  _createVNode(_component_v_btn, { onClick: login }, {
                    default: _withCtx(() => [
                      _createTextVNode("Register")
                    ]),
                    _: 1
                  })
                ]))
              : (_unref(registered))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, " You are already registered and logged in. Select 'Application' on the left menu to submit an application, or 'Application Status' to check the status of an existing Application. "))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})